import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the absenceDetail state domain
 */

const selectAbsenceDetailDomain = state => state.absenceDetail || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Absence
 */

const selectAbsenceData = () =>
  createSelector(
    selectAbsenceDetailDomain,
    substate => substate.absenceData,
  );

const selectAbsenceLoading = () =>
  createSelector(
    selectAbsenceDetailDomain,
    substate => substate.loading,
  );

const selectAbsenceLoadingUpdate = () =>
  createSelector(
    selectAbsenceDetailDomain,
    substate => substate.loadingUpdate,
  );

const selectAbsenceError = () =>
  createSelector(
    selectAbsenceDetailDomain,
    substate => substate.error,
  );

const selectAbsenceDeleteSuccessful = () =>
  createSelector(
    selectAbsenceDetailDomain,
    substate => substate.deleteSuccessful,
  );

export {
  selectAbsenceDetailDomain,
  selectAbsenceData,
  selectAbsenceLoading,
  selectAbsenceError,
  selectAbsenceDeleteSuccessful,
  selectAbsenceLoadingUpdate,
};
